import { render, staticRenderFns } from "./SubcategorySelector.vue?vue&type=template&id=676650f3&scoped=true"
import script from "./SubcategorySelector.vue?vue&type=script&lang=js"
export * from "./SubcategorySelector.vue?vue&type=script&lang=js"
import style0 from "./SubcategorySelector.vue?vue&type=style&index=0&id=676650f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676650f3",
  null
  
)

export default component.exports